var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { SlEye } from 'react-icons/sl';
import { LuPencil } from 'react-icons/lu';
export const RowActionCell = React.memo((_a) => {
    var { row, onView, onDelete, onEdit } = _a, hide = __rest(_a, ["row", "onView", "onDelete", "onEdit"]);
    return (_jsxs("div", Object.assign({ style: { display: 'flex', gap: '10px', justifyContent: 'end' } }, { children: [!!onView && (hide.hideView ? !hide.hideView(row) : true) && (_jsx(SlEye, { className: 'table-icon', onClick: () => onView(row.id) })), !!onEdit && (hide.hideEdit ? !hide.hideEdit(row) : true) && (_jsx(LuPencil, { className: 'table-icon', onClick: () => onEdit(row.id) })), !!onDelete && (hide.hideDelete ? !hide.hideDelete(row) : true) && (_jsx(RiDeleteBin6Line, { className: 'table-icon', onClick: () => onDelete(row.id) }))] })));
});
RowActionCell.displayName = 'RowActionCell';
